import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import { createSearchParams, useSearchParams, useNavigate } from 'react-router-dom';
import { objectToQueryString, apiHelper, baseUrl } from 'helpers/util';
import { notify } from 'helpers/globalFunctions';

import ColumnBox from 'components/ColumnBox';
import RowBox from 'components/RowBox';
import CardList from 'components/CardList';
import CardItem from 'components/CardItem';
import SmallestHeading from 'components/SmallestHeading';
import SmallHeading from 'components/SmallHeading';


export default function Form(props) {
    const warehouse = props.warehouse;

    const navigate = useNavigate();
    const [ productId, setProductId ] = useState(null);
    const [ productName, setProductName ] = useState('');
    const [ cost, setCost ] = useState('');
    const [ unit, setUnit ] = useState(null);
    const [ unitOptions, setUnitOptions ] = useState([]);
    const [ isVegetable, setIsVegetable] = useState(false);

    const [ products, setProducts ] = useState([]);

    const [ isFormSubmitting, setIsFormSubmitting ] = useState(false);

    const fillProductDetails = function(productInfo) {
        setProductId(productInfo ? productInfo.name : null);
        setProductName(productInfo ? productInfo.product_name : '');
        setIsVegetable(productInfo ? productInfo.is_vegetable : false);
        setCost(productInfo ? productInfo.cost : '');
        setUnit(productInfo ? productInfo.unit : null);
    }

    const loadProducts = function() {
        const apiParams = {
            "doctype": "Store Product",
            "fields": JSON.stringify(["name", "product_name", "cost", "unit", "is_vegetable"]),
            "order_by": "product_name asc",
            "limit": 1000,
            "filters": JSON.stringify([[ 'warehouse', '=', warehouse ]])
        }
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_api`,
            "params": apiParams })
        .then(response => {
            if (response.status) { setProducts(response.json.data); }
            else { console.log(response.json); }
        })
    }

    const loadUnitOptions = function() {
        const apiParams = {
            "doctype": "Store UOM",
            "fields": JSON.stringify(["name"]),
            "order_by": "name asc",
            "limit": 1000,
        }
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_api`,
            "params": apiParams })
        .then(response => {
            if (response.status) { setUnitOptions(response.json.data.map(el => el.name)); }
            else { console.log(response.json); }
        })
    }

    const onClickSave = function() {
        const payload = {
            'product_name': productName,
            'is_vegetable': isVegetable,
            unit, cost, warehouse
        }

        const apiParams = { "doctype": "Store Product" };
        productId && (apiParams["name"] = productId)

        setIsFormSubmitting(true);
        let apiUrl = `${baseUrl}/.netlify/functions/erp_api`;
        let apiPromise = null;
        if (productId) {
            apiPromise = apiHelper.put({ "url": apiUrl, "params": apiParams, "data": payload })
        } else {
            apiPromise = apiHelper.post({ "url": apiUrl, "params": apiParams, "data": payload })
        }
        apiPromise
        .then(response => {
            if (response.status) {
                setIsFormSubmitting(false);
                fillProductDetails();
                loadProducts();
                notify.success({ "description": "Product successfully added !" })
            } else { console.log(response.json); setIsFormSubmitting(false); }
        })
    }

    useEffect(function() {
        loadProducts();
        loadUnitOptions();
    }, [])

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',
            padding: '15px' }}>
            <ColumnBox>
                <SmallHeading>Add / Edit Product</SmallHeading>
                <ColumnBox sx={{ alignItems: 'center', maxWidth: '500px',
                    width: '100%' }}>
                    <TextField label="Product Name"
                        onChange={(e) => setProductName(e.target.value)}
                        value={productName}
                        sx={{ width: '100%', marginTop: '15px' }}
                        type="text"
                        size="small"
                    />
                    <FormControlLabel sx={{ alignSelf: 'flex-start' }}
                        control={<Checkbox size="small" checked={isVegetable}
                        onChange={ e => setIsVegetable(e.target.checked) } />}
                        label="Vegetable ?" />

                    <TextField label="Cost"
                        onChange={(e) => setCost(e.target.value)}
                        value={cost}
                        sx={{ width: '100%', marginTop: '15px' }}
                        type="number"
                        size="small"
                    />
                    <Autocomplete
                        disablePortal
                        size="small"
                        onChange={(e, newValue) => { setUnit(newValue); }}
                        options={unitOptions}
                        value={unit}
                        sx={{ width: '100%', marginTop: '15px' }}
                        renderInput={(params) => <TextField {...params} label="Unit" />}
                    />

                    { isFormSubmitting ? <CircularProgress sx={{ marginTop: '15px' }} /> :
                        <Button sx={{ marginTop: '15px' }} onClick={() => onClickSave()}
                            variant="outlined">Save</Button>
                    }
                </ColumnBox>
                <SmallHeading>Products</SmallHeading>
                <CardList sx={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                    { products.map(p => (
                        <CardItem sx={{ 'cursor': 'pointer', 'minWidth': '70px',
                            'width': 'unset', 'maxWidth': '200px', 'margin': '10px 5px' }}
                            onClick={() => fillProductDetails(p)}>
                            <Box>{`${p.product_name}${p.is_vegetable ? ' 🥬' : '' }`}</Box>
                            <RowBox>
                                <Box>{p.cost !== null && `₹ ${p.cost}/ ` }</Box>
                                <Box>{p.unit}</Box>
                            </RowBox>
                        </CardItem>
                    )) }
                </CardList>
            </ColumnBox>
        </Box>
    );
}
